import React, { useState } from "react";

const BuyTokenModel = ({
  find_Exp_usdt,
  find_Exp_Token,
  buying_Amount,
  set_buying_Amount,
  selling_Amount,
  set_selling_Amount,
  purchaseToken,
  sellToken,
}) => {

  const [activeTab, setActiveTab] = useState("Buy");

  return (
    <div className="tw-min-h-[440px] tw-w-[540px] tw-bg-white tw-rounded-[10px] tw-flex tw-flex-col tw-max-[480px]:tw-w-full tw-max-[480px]:tw-min-h-[340px]">

      {/* Header */}
      <div className="tw-flex tw-w-full">
        <button
          className={`tw-flex-1 tw-text-[20px] tw-font-medium tw-py-2 tw-transition-all 
          ${
            activeTab === "Buy"
              ? "tw-bg-purple-500 tw-text-black"
              : "tw-bg-[#050023e2] tw-text-white"
          }`}
          onClick={() => setActiveTab("Buy")}
        >
          Buy WLB
        </button>

        <button
          className={`tw-flex-1 tw-text-[20px] tw-font-medium tw-py-2 tw-transition-all
          ${
            activeTab === "Sell"
              ? "tw-bg-purple-500 tw-text-black"
              : "tw-bg-[#050023e2] tw-text-white"
          }`}
          onClick={() => setActiveTab("Sell")}
        >
          Sell WLB
        </button>
      </div>

      {/* PURCHASE TAB */}
      {activeTab === "Buy" && (
        <div className="tw-px-[35px] tw-py-[25px] tw-flex tw-flex-col tw-max-[480px]:tw-px-[24px] tw-max-[480px]:tw-py-[15px]">

          <h1 className="tw-text-[#161616] tw-text-[30px] tw-font-semibold tw-mb-4 tw-max-[480px]:tw-text-[18px]">
            BUY WLB Token
          </h1>

          <div className="tw-flex tw-flex-col tw-my-[28px]">

            <div className="tw-flex tw-justify-between tw-mb-4">
              <h1 className="tw-text-[14px] tw-text-[#1d1d1d]">
                Enter Amount in USDT
              </h1>
              <h1 className="tw-text-[14px] tw-text-[#1d1d1d]">
                1 WLB = 0.05$
              </h1>
            </div>

            <input
              type="number"
              placeholder="0.0"
              value={buying_Amount}
              onChange={(e)=>{set_buying_Amount(e.target.value)}}
              className="tw-text-white tw-px-[10px] tw-py-[12px] tw-rounded-[10px] tw-bg-[#050023] tw-border tw-border-transparent focus:tw-border-purple-500 tw-outline-none"
            />

          </div>

          <div className="tw-flex tw-flex-col tw-w-full">

            <div className="tw-flex tw-justify-between tw-mb-[12px]">
              <label className="tw-text-[14px] tw-text-[#161616]">
                Expected WLB Token
              </label>
              <label className="tw-text-[14px] tw-font-medium tw-text-[#161616]">
              {find_Exp_Token()}
              </label>
            </div>

            {/* <div className="tw-flex tw-justify-between tw-mb-[12px]">
              <label className="tw-text-[14px] tw-text-[#161616]">
                Expected Return
              </label>
              <label className="tw-text-[14px] tw-font-medium tw-text-[#161616]">
                900
              </label>
            </div> */}

          </div>

          <button
            onClick={purchaseToken}
            className="tw-mt-8 tw-bg-[#050023] tw-text-white tw-py-2 tw-rounded-[8px] tw-uppercase hover:tw-opacity-90 tw-transition"
          >
            Buy Now
          </button>

        </div>
      )}

      {/* SALE TAB */}
      {activeTab === "Sell" && (
        <div className="tw-px-[35px] tw-py-[25px] tw-flex tw-flex-col tw-max-[480px]:tw-px-[24px] tw-max-[480px]:tw-py-[15px]">

          <h1 className="tw-text-[#161616] tw-text-[30px] tw-font-semibold tw-mb-4 tw-max-[480px]:tw-text-[18px]">
            Sale WLB Token
          </h1>

          <div className="tw-flex tw-flex-col tw-my-[28px]">

            <div className="tw-flex tw-justify-between tw-mb-4">
              <h1 className="tw-text-[14px] tw-text-[#1d1d1d]">
                Enter Your Amount 
              </h1>
              <h1 className="tw-text-[14px] tw-text-[#1d1d1d]">
              1 WLB = 0.05$
              </h1>
            </div>

            <input
              type="number"
              placeholder="0.0"
              value={selling_Amount}
              onChange={(e)=>{set_selling_Amount(e.target.value)}} 

              className="tw-text-white tw-px-[10px] tw-py-[12px] tw-rounded-[10px] tw-bg-[#050023] tw-border tw-border-transparent focus:tw-border-purple-500 tw-outline-none"
            />

          </div>

          <div className="tw-flex tw-flex-col tw-w-full">

            <div className="tw-flex tw-justify-between tw-mb-[12px]">
              <label className="tw-text-[14px] tw-text-[#161616]">
                Expected USDT
              </label>
              <label className="tw-text-[14px] tw-font-medium tw-text-[#161616]">
              {find_Exp_usdt()}
              </label>
            </div>

            {/* <div className="tw-flex tw-justify-between tw-mb-[12px]">
              <label className="tw-text-[14px] tw-text-[#161616]">
                Expected Return
              </label>
              <label className="tw-text-[14px] tw-font-medium tw-text-[#161616]">
                900
              </label>
            </div> */}

          </div>

          <button
            onClick={sellToken}
            className="tw-mt-8 tw-bg-[#050023] tw-text-white tw-py-2 tw-rounded-[8px] tw-uppercase hover:tw-opacity-90 tw-transition"
          >
            Sale Now
          </button>

        </div>
      )}

    </div>
  );
};

export default BuyTokenModel;